import React, { Component } from 'react';
import PropTypes from 'prop-types';

class StandardButton extends Component {
  render() {
    const {
      id, className, onClick, children, disabled,
    } = this.props;
    return (
      <button
        id={id}
        type="button"
        className={className}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    );
  }
}

StandardButton.defaultProps = {
  className: 'form-control btn-outline-primary',
  disabled: false,
};
StandardButton.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.any,
  disabled: PropTypes.bool,
};

export default StandardButton;
